export const normalizeConnectionSnsList = (snsList = {}) => {
  if (!snsList) {
    return []
  }
  return snsList.map((sns) => {
    const {
      connection_date: connectionDate,
      sns_id: snsId,
      provider_id: providerId,
      provider_name: providerName,
      // state - 1: 연결, 2: 미연결
      state,
      // state_desc - 버튼에 표시할 내용 (연결하기/해제하기)
      state_desc: stateText,
    } = sns
    return {
      connectionDate,
      snsId,
      providerId,
      providerName,
      state: state === 1,
      stateText,
    }
  })
}

export const normalizeConnections = (rawData = {}) => {
  if (!rawData || !rawData?.data) {
    return {
      ...rawData,
      date: undefined,
    }
  }
  const { id: wavveId, sns: snsList } = rawData.data
  return {
    ...rawData,
    data: {
      wavveId,
      snsList: normalizeConnectionSnsList(snsList),
    },
  }
}
